import { InjectionToken } from '@angular/core';
import { SettingsConfig } from './models/settings-config.interface';

export const SETTINGS_CONFIG = new InjectionToken<SettingsConfig>('CertMetrics Settings Configuration');
